import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import { Title } from 'react-admin';

export const Dashboard = () => {
    const [permissions, setPermissions] = useState(() => JSON.parse(localStorage.getItem('permissions')) || []);
    const [applications, setApplications] = useState([]);
    const roles = JSON.parse(localStorage.getItem('roles')) || [];

    const portalBaseUrl =
        process.env.NODE_ENV === 'development'
            ? 'http://localhost'
            : 'https://portal.wmca.org.uk';

    const hasThriveUserAccess = roles.includes('THRIVE_user');
    const hasThriveAdminAccess = roles.includes('THRIVE_admin');
    const thriveUrl = hasThriveAdminAccess
        ? `${portalBaseUrl}/thrive/admin/`
        : hasThriveUserAccess
            ? `${portalBaseUrl}/thrive/`
            : null;

    const handleClick = (url) => {
        if (url) {
            window.location.href = url;
        }
    };

    useEffect(() => {
        const userApplications = [...new Set(permissions.map((permission) => permission.application))];
        setApplications(userApplications);
    }, [permissions]);

    const renderButton = (projectName, url, buttonText) => {
        const hasAccess = applications.includes(projectName);

        return (
            <Button
                variant="contained"
                color={hasAccess ? 'primary' : 'secondary'}
                onClick={hasAccess ? () => handleClick(url) : null}
                disabled={!hasAccess}
                sx={{
                    marginTop: 2,
                    padding: '10px 20px',
                    fontSize: '1rem',
                    alignSelf: 'center',
                }}
            >
                {buttonText + (hasAccess ? (buttonText === '' ? ' Get Started' : '') : ' No Access, Contact Admin')}
            </Button>
        );
    };

    return (
        <Card sx={{ padding: 4, backgroundColor: '#f9f9f9' }}>
            <Title title="List of Current Projects" />
            <CardContent>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 4,
                    }}
                >
                    <Box
                        sx={{
                            width: '100%',
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            backgroundColor: '#fff',
                            boxShadow: 2,
                            padding: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: 2, textAlign: 'center' }}>
                            UKSPF Project
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2, textAlign: 'center' }}>
                            The UK Shared Prosperity Fund (UKSPF or the Fund) is a central pillar of the UK government’s ambitious Levelling Up agenda and a significant component of its support for places across the UK. It provides £2.6 billion of new funding for local investment by March 2025, with all areas of the UK receiving an allocation from the Fund via a funding formula rather than a competition. It will help places right across the country deliver enhanced outcomes and recognises that even the most affluent parts of the UK contain pockets of deprivation and need support.
                        </Typography>
                        {renderButton('UKSPF', `${portalBaseUrl}/ukspf/`, '2022/23 - CLOSED')}
                        {renderButton('UKSPF2', `${portalBaseUrl}/ukspf2/`, 'Integrated Settlement 25-26 UKSPF')}
                    </Box>
                    {[
                        {
                            title: 'Thrive at Work',
                            description:
                                'Thrive at Work is a workplace commitment with criteria and guidelines on creating a workplace that promotes employee health and wellbeing, focusing on key organisational enablers of health such as attendance management, policies and procedures in addition to health areas such as mental, musculoskeletal and physical health and promoting healthy lifestyles.',
                            project: 'THRIVE',
                            url: thriveUrl || `${portalBaseUrl}/thrive/`,
                        },
                        {
                            title: 'Connect to Work',
                            description:
                                'Connect to work',
                            project: 'CONNECTTOWORK',
                            url: `${portalBaseUrl}/connecttowork/`,
                        },
                        {
                            title: 'Commonwealth Games Project',
                            description:
                                'Supporting the legacy of the Games through investment...',
                            project: 'CWGLEF',
                            url: `${portalBaseUrl}/cwglef/`,
                        },
                        {
                            title: 'Digital Divide Portal',
                            description:
                                'The Digital Divide portal is a monthly reporting tool for organisations delivering activity relating to the Digital Divide project across WMCA. Lead organisations are required to report on project level expenditure, outputs and outcomes against their specified projects on a monthly basis. Data entered onto the portal will determine payments and performance in line with details included in the Digital Divide Operational plan',
                            project: 'DIGITALDIVIDE',
                            url: `${portalBaseUrl}/digitaldivide/`,
                        },
                        {
                            title: 'Youth Trailblazer',
                            description:
                                '',
                            project: 'YOUTHTRAILBLAZER',
                            url: `${portalBaseUrl}/youthtrailblazer/`,
                        },
                        {
                            title: 'Employment Support Transition Fund',
                            description:
                                '',
                            project: 'ESTF',
                            url: `${portalBaseUrl}/estf/`,
                        },
                        {
                            title: 'Wraparound Portal',
                            description:
                                'The Wraparound Portal allows training providers to securely submit their wrap-around support, learner support and funding licence cost claims digitally. Claims are used to calculate Earnings Adjustment Statement (EAS) claims for individual contracts within the Adult Skills programme, and feed into the overall payment process.',
                            project: 'WRAPAROUNDS2627',
                            url: `${portalBaseUrl}/wraparounds2627/`,
                        },
                    ].map((project, index) => (
                        <Box
                            key={index}
                            sx={{
                                width: '100%',
                                border: '1px solid #ddd',
                                borderRadius: 2,
                                backgroundColor: '#fff',
                                boxShadow: 2,
                                padding: 4,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: 2, textAlign: 'center' }}>
                                {project.title}
                            </Typography>
                            <Typography variant="body1" sx={{ marginBottom: 2, textAlign: 'center' }}>
                                {project.description}
                            </Typography>
                            {renderButton(project.project, project.url, '')}
                        </Box>
                    ))}
                    <Box
                        sx={{
                            width: '100%',
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            backgroundColor: '#fff',
                            boxShadow: 2,
                            padding: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: 2, textAlign: 'center' }}>
                            Adult Skills Fund Destinations
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2, textAlign: 'center' }}>
                            Destination and Progression information is a mandatory data collection and a requirement of funding for all WMCA procured and non-procured contracts.
                            The recording of Destination and Progression enables us to ensure that West Midlands residents are receiving value for money and allows us to monitor the learners journey through Adult Education.
                            Please refer to the Coding Guidance for more information on Destination and Progression reporting, including when data should be returned based on your contract and the specific collection requirements.
                        </Typography>
                        {renderButton('SKILLS', `${portalBaseUrl}/skills/`, '2025/26 - Enrolments')}
                        {renderButton('DESTINATIONS', `${portalBaseUrl}/destinations/`, '2026/27 - Enrolments and Learners')}
                    </Box>
                    <Box
                        sx={{
                            width: '100%',
                            border: '1px solid #ddd',
                            borderRadius: 2,
                            backgroundColor: '#fff',
                            boxShadow: 2,
                            padding: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h5" sx={{ fontWeight: 600, marginBottom: 2, textAlign: 'center' }}>
                            Business Economy
                        </Typography>
                        <Typography variant="body1" sx={{ marginBottom: 2, textAlign: 'center' }}></Typography>
                        {renderButton('BUSINESSECONOMY', `${portalBaseUrl}/businesseconomy/`, '2022/23 - CLOSED')}
                        {renderButton('BUSINESSECONOMY2', `${portalBaseUrl}/businesseconomy2/`, 'Local Enterprise Support - 2026/27')}
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

